import { getStoragePublicUrl, isSupabaseConfigured } from "../lib/supabaseClient";
import { isSupabaseBackend } from "../services/config";

const AZURE_STORAGE_BASE =
  process.env.REACT_APP_Image_Url || "https://payinapoapistorage.blob.core.windows.net/images/";

/** Generated letter tiles / OAuth default avatars — not real dating photos. */
export function isLetterOrPlaceholderAvatarUrl(uri) {
  if (!uri || typeof uri !== "string") return true;
  const lower = uri.trim().toLowerCase();
  if (!lower) return true;
  if (lower.includes("ui-avatars.com")) return true;
  if (lower.includes("via.placeholder")) return true;
  if (lower.includes("placeholder")) return true;
  if (lower.includes("googleusercontent.com")) return true;
  if (lower.includes("ggpht.com")) return true;
  if (lower.includes("gravatar.com")) return true;
  return false;
}

function isBuggyImageUriLocal(uri) {
  if (!uri || typeof uri !== "string") return true;
  const lower = uri.trim().toLowerCase();
  if (!lower) return true;
  if (lower.includes("/images/string") || lower.endsWith("/images/")) return true;
  if (lower.includes("placeholder") || lower.includes("via.placeholder")) return true;
  return false;
}

function isUsablePhotoUri(uri) {
  if (!uri || typeof uri !== "string") return false;
  if (isBuggyImageUriLocal(uri) || isLetterOrPlaceholderAvatarUrl(uri)) return false;
  return true;
}

export function resolveProfileImageUrl(person) {
  if (!person) return null;

  if (person.profileImageUri && isUsablePhotoUri(person.profileImageUri)) {
    const uri = person.profileImageUri;
    if (uri.startsWith("http")) return uri;
    if (isSupabaseBackend() && isSupabaseConfigured) {
      const fromStorage = getStoragePublicUrl(uri);
      if (fromStorage) return fromStorage;
    }
    return `${AZURE_STORAGE_BASE}${uri}`;
  }

  const images = person.images;
  if (Array.isArray(images) && images.length > 0) {
    for (const first of images) {
      const fileName = typeof first === "string" ? first : first?.fileName;
      const storagePath = typeof first === "object" ? first?.storagePath ?? first?.storage_path : null;

      if (storagePath && isSupabaseBackend() && isSupabaseConfigured) {
        const url = getStoragePublicUrl(storagePath);
        if (url && isUsablePhotoUri(url)) return url;
      }
      if (first?.url && isUsablePhotoUri(first.url)) return first.url;
      if (fileName) {
        if (fileName.startsWith("http")) {
          if (isUsablePhotoUri(fileName)) return fileName;
        } else {
          return `${AZURE_STORAGE_BASE}${fileName}`;
        }
      }
    }
  }

  const name =
    [person.firstName, person.lastName].filter(Boolean).join(" ").trim() ||
    person.email ||
    "User";
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&size=256&background=E9D5FF&color=6B21A8`;
}

export function resolveImageUrl(image) {
  if (!image) return null;
  if (image.url) return image.url;
  const storagePath = image.storagePath ?? image.storage_path;
  if (storagePath && isSupabaseBackend() && isSupabaseConfigured) {
    return getStoragePublicUrl(storagePath);
  }
  const fileName = image.fileName ?? image.file_name;
  if (!fileName) return null;
  if (fileName.startsWith("http")) return fileName;
  return `${AZURE_STORAGE_BASE}${fileName}`;
}

export function resolveDisplayName(person, fallback = "Someone") {
  if (!person) return fallback;
  const full = [person.firstName, person.lastName].filter(Boolean).join(" ").trim();
  return full || person.firstName || fallback;
}
